import { useMemo } from "react";

export const usePagination = (page: number, array: any[] = [], size: number = 10) => {
  const data = useMemo(() => {
    var result: any = [];
    if (!array) return result;
    page = parseInt(page.toString());
    size = parseInt(size.toString());
    const skip = (page - 1) * size;
    const end = skip + size;
    var part = array.slice(skip, end);
    return part;
  }, [array, size, page]);

  const total: number = useMemo(() => array?.length || 0, [array]);
  return {
    data,
    total,
  };
};
